(() => {
  const MOBILE_MQ = "(max-width: 749px)";

  function formatMoney(cents) {
    if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      const format = (window.theme && window.theme.money_format) || "${{amount}}";
      return Shopify.formatMoney(cents, format);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function initSection(root) {
    if (root.dataset.ppfInit === "true") return;
    root.dataset.ppfInit = "true";

    const container = root.closest(".ppf-section");
    const mainImage = root.querySelector("[data-ppf-main-image]");
    const thumbs = root.querySelectorAll("[data-ppf-thumb]");
    const thumbsTrack = root.querySelector("[data-ppf-thumbs]");
    const thumbsRail = root.querySelector("[data-ppf-thumbs-rail]");
    const prevThumbsBtn = root.querySelector("[data-ppf-thumb-prev]");
    const nextThumbsBtn = root.querySelector("[data-ppf-thumb-next]");
    const payloadEl = container?.querySelector("[data-ppf-images]");
    const sizeButtons = root.querySelectorAll("[data-ppf-size]");
    const variantInput = root.querySelector("[data-ppf-variant-input]");
    const atcButton = root.querySelector("[data-ppf-atc]");
    const currentPriceEl = root.querySelector("[data-ppf-price-current]");
    const comparePriceEl = root.querySelector("[data-ppf-price-compare]");
    const saveEl = root.querySelector("[data-ppf-save]");

    let payload = { media: [], variants: [] };
    if (payloadEl) {
      try {
        payload = JSON.parse(payloadEl.textContent.trim());
      } catch (err) {
        console.warn("[peak-product-focus] Could not parse media JSON", err);
      }
    }

    const mediaById = {};
    payload.media.forEach((item) => {
      mediaById[String(item.id)] = item;
    });

    const getMediaFromThumb = (thumb) => {
      const id = thumb.dataset.mediaId;
      if (mediaById[String(id)]) return mediaById[String(id)];
      return {
        id,
        src: thumb.dataset.mediaSrc,
        srcset: thumb.dataset.mediaSrcset,
        alt: thumb.dataset.mediaAlt || thumb.querySelector("img")?.alt || "",
      };
    };

    const setMainImage = (media) => {
      if (!mainImage || !media?.src) return;
      mainImage.src = media.src;
      if (media.srcset) mainImage.srcset = media.srcset;
      else mainImage.removeAttribute("srcset");
      if (media.alt) mainImage.alt = media.alt;
    };

    let thumbIndex = 0;
    const thumbGap = 8;

    const getVisibleThumbs = () => {
      if (!container) return 4;
      const val = getComputedStyle(container).getPropertyValue("--ppf-visible-thumbs").trim();
      const n = parseInt(val, 10);
      return Number.isFinite(n) && n > 0 ? n : 4;
    };

    const getThumbStep = () => {
      const first = thumbs[0];
      if (!first) return 0;
      return first.getBoundingClientRect().height + thumbGap;
    };

    const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

    const maxThumbIndex = () => {
      if (isMobile()) return 0;
      return Math.max(0, thumbs.length - getVisibleThumbs());
    };

    const updateThumbRail = () => {
      if (!thumbsTrack) return;

      const visible = getVisibleThumbs();
      const max = maxThumbIndex();
      const needsNav = !isMobile() && thumbs.length > visible;

      if (thumbsRail) thumbsRail.classList.toggle("is-static", !needsNav);

      if (thumbIndex > max) thumbIndex = max;
      if (thumbIndex < 0) thumbIndex = 0;

      if (isMobile()) {
        thumbsTrack.style.transform = "none";
        if (prevThumbsBtn) prevThumbsBtn.disabled = true;
        if (nextThumbsBtn) nextThumbsBtn.disabled = true;
        return;
      }

      thumbsTrack.style.transform = `translateY(-${thumbIndex * getThumbStep()}px)`;
      if (prevThumbsBtn) prevThumbsBtn.disabled = !needsNav || thumbIndex === 0;
      if (nextThumbsBtn) nextThumbsBtn.disabled = !needsNav || thumbIndex >= max;
    };

    const ensureThumbVisible = (mediaId) => {
      if (isMobile()) return;
      const targetIndex = Array.from(thumbs).findIndex(
        (t) => String(t.dataset.mediaId) === String(mediaId)
      );
      if (targetIndex === -1) return;

      const visible = getVisibleThumbs();
      const max = maxThumbIndex();
      if (targetIndex < thumbIndex) thumbIndex = targetIndex;
      if (targetIndex > thumbIndex + (visible - 1)) {
        thumbIndex = Math.min(max, targetIndex - (visible - 1));
      }
      updateThumbRail();
    };

    const activateThumb = (thumb) => {
      const media = getMediaFromThumb(thumb);
      setMainImage(media);
      thumbs.forEach((t) => t.classList.remove("is-active"));
      thumb.classList.add("is-active");
      ensureThumbVisible(thumb.dataset.mediaId);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", (e) => {
        e.preventDefault();
        activateThumb(thumb);
      });
    });

    if (prevThumbsBtn) {
      prevThumbsBtn.addEventListener("click", (e) => {
        e.preventDefault();
        thumbIndex -= 1;
        updateThumbRail();
      });
    }

    if (nextThumbsBtn) {
      nextThumbsBtn.addEventListener("click", (e) => {
        e.preventDefault();
        thumbIndex += 1;
        updateThumbRail();
      });
    }

    sizeButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        const variant = payload.variants.find((v) => String(v.id) === String(variantId));
        if (!variant) return;

        sizeButtons.forEach((item) => item.classList.remove("is-active"));
        btn.classList.add("is-active");

        if (variantInput) variantInput.value = variant.id;
        if (atcButton) atcButton.disabled = !variant.available;

        if (currentPriceEl) currentPriceEl.textContent = formatMoney(variant.price);

        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.hidden = false;
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          } else {
            comparePriceEl.hidden = true;
            comparePriceEl.textContent = "";
          }
        }

        if (saveEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            const saveAmount = variant.compare_at_price - variant.price;
            const savePct = Math.round((saveAmount / variant.compare_at_price) * 100);
            saveEl.textContent = `You save ${formatMoney(saveAmount)} (${savePct}%)`;
          } else {
            saveEl.textContent = "";
          }
        }

        const featuredId = variant.featured_image?.id || variant.featured_media?.id;
        if (featuredId) {
          const activeThumb = root.querySelector(`[data-ppf-thumb][data-media-id="${featuredId}"]`);
          if (activeThumb) activateThumb(activeThumb);
        }
      });
    });

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateThumbRail, 120);
    });

    updateThumbRail();
  }

  function boot() {
    document.querySelectorAll("[data-ppf-root]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target.querySelector("[data-ppf-root]");
    if (root) initSection(root);
  });
})();
